import type { PrimaryRampStep } from './colorDerivation';

export const HAIC_L1_PRIMARY_VAR = (step: PrimaryRampStep) => `--haic-color-l1-primary-${step}`;

/** Legacy Fluent compat var; read-only for override precedence (#8066). */
export const H2O_PRIMARY_VAR = (step: PrimaryRampStep) => `--h2o-primary${step}`;

export const HAIC_L2_TEXT_ON_ACCENT_VAR = '--haic-color-l2-text-on-accent';

export const HAIC_L1_PRIMARY_ANCHOR_VAR = HAIC_L1_PRIMARY_VAR(500);
